import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Smartphone, Layers, Gauge, Wifi } from 'lucide-react';
const features = [{
  icon: Layers,
  title: 'Up to 10 zones',
  body: 'Independent control room by room'
}, {
  icon: Gauge,
  title: 'Per room temperature',
  body: 'Set the bedroom cooler than the lounge'
}, {
  icon: Smartphone,
  title: 'iPhone and Android',
  body: 'Run it from anywhere with Wi-Fi'
}, {
  icon: Wifi,
  title: 'Voice control ready',
  body: 'Works with Alexa and Google'
}];
const zones = [{
  name: 'Master',
  temp: '21°',
  active: true
}, {
  name: 'Kids 1',
  temp: '22°',
  active: true
}, {
  name: 'Lounge',
  temp: '23°',
  active: true
}, {
  name: 'Kitchen',
  temp: 'off',
  active: false
}, {
  name: 'Office',
  temp: 'off',
  active: false
}, {
  name: 'Guest',
  temp: 'off',
  active: false
}];
export function SmartZone() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-684" data-mp="3lntzwnsrhg9r">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-685" data-mp="3lqpy8d8iu6yq">
        <div className="bg-brand text-white rounded-3xl overflow-hidden relative shadow-2xl" data-id="element-686" data-mp="3gqu373hsxpvb">
          <div className="grid lg:grid-cols-12 gap-0 items-stretch" data-id="element-687" data-mp="3uqd2d6smxqvh">
            {/* Content */}
            <div className="lg:col-span-7 p-8 sm:p-12 lg:p-16" data-id="element-688" data-mp="3pp5p4s7q3zhf">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} data-id="element-689" data-mp="8htv6a7tymaz">
                <div className="inline-flex items-center gap-2 px-3 h-7 rounded-full bg-white/10 text-xs font-semibold uppercase tracking-widest mb-6 text-white/90" data-id="element-690" data-mp="r81tmf0l4oku">
                  <Smartphone size={13} data-id="element-691" data-mp="m7dvzahup9hn" /> Powered by iZone
                </div>
                <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-[1.1] mb-6" data-id="element-692" data-mp="3g3b3ib2m2bhj">
                  Pay only for the rooms you use.
                </h2>
                <p className="text-lg leading-relaxed text-white/85 max-w-xl mb-8" data-id="element-693" data-mp="3p13itf8c1j4x">
                  We pair every ducted install with{' '}
                  <strong className="text-white" data-id="element-694" data-mp="3tuxxg492z7x5">iZone Smart Home</strong>,
                  Australian made zone control that lets you run only the rooms
                  you are in, from your phone, with per room temperature, fan
                  speed and timers. Saves around 40% on running costs.
                </p>

                <div className="grid sm:grid-cols-2 gap-3 mb-9" data-id="element-695" data-mp="gm32fiigfyx1">
                  {features.map((feature, i) => {
                  const Icon = feature.icon;
                  return <div key={i} className="flex items-start gap-3 p-4 rounded-xl bg-white/[0.06] border border-white/10" data-id="element-696" data-mp="2idpsnhuivpsg" data-mpi={i}>
                        <div className="w-9 h-9 rounded-lg bg-accent text-ink flex items-center justify-center flex-shrink-0" data-id="element-697" data-mp="263grexrr7z7r">
                          <Icon size={16} data-id="element-698" data-mp="213m1oxjptfoa" />
                        </div>
                        <div data-id="element-699" data-mp="1w5kh286n58ap">
                          <div className="font-semibold text-sm leading-tight mb-0.5" data-id="element-700" data-mp="1w6c24p2m3nmq">
                            {feature.title}
                          </div>
                          <div className="text-xs text-white/70 leading-snug" data-id="element-701" data-mp="2otydwklztyko">
                            {feature.body}
                          </div>
                        </div>
                      </div>;
                })}
                </div>

                <a href="/smart-zone/" className="inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-accent hover:bg-accent-600 text-ink text-base font-bold transition-all hover:scale-[1.02] shadow-lg shadow-accent/20" data-id="element-702" data-mp="2ft06dsccj8xc">
                  Explore iZone Smart Home
                  <ArrowRight size={16} strokeWidth={2.5} data-id="element-703" data-mp="2x1j1pbse2dvq" />
                </a>
              </motion.div>
            </div>

            {/* Visual side: SVG phone mockup */}
            <div className="lg:col-span-5 relative bg-brand-700 p-8 lg:p-12 flex items-center justify-center min-h-[400px] lg:min-h-[600px] overflow-hidden" data-id="element-704" data-mp="2ieg3f2w8s17c">
              <div className="absolute inset-0 opacity-[0.08]" style={{
              backgroundImage: 'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
              backgroundSize: '32px 32px'
            }} data-id="element-705" data-mp="3b10x4a06wpe2"></div>

              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.3
            }} className="relative w-[240px] sm:w-[280px] aspect-[9/19] bg-ink rounded-[36px] border-[6px] border-stone-900 shadow-2xl overflow-hidden" data-id="element-706" data-mp="1qlp42jj9hwdv">
                <div className="px-5 pt-3 pb-1 flex items-center justify-between text-[10px] text-white/80 font-medium" data-id="element-707" data-mp="14d1mhlix1mb0">
                  <span className="tabular-nums" data-id="element-708" data-mp="zegta62302w2">9:41</span>
                  <span data-id="element-709" data-mp="zbugns0c2x6z">iZone</span>
                </div>

                <div className="px-5 pt-4 pb-5" data-id="element-710" data-mp="1e3whpfe53w8l">
                  <div className="text-[10px] uppercase tracking-widest text-white/50 font-semibold mb-1" data-id="element-711" data-mp="1e4o2dv6789k3">
                    Your home
                  </div>
                  <div className="text-white text-2xl font-bold tracking-tight leading-tight" data-id="element-712" data-mp="lkzcgt0s549q">
                    24°C <span className="text-accent" data-id="element-713" data-mp="gmxu6ab6h8zb">●</span>
                  </div>
                  <div className="text-[10px] text-white/60 mt-0.5" data-id="element-714" data-mp="16ajsxufek70n">
                    3 of 6 zones active
                  </div>
                </div>

                <div className="px-3 space-y-2" data-id="element-715" data-mp="1f3wshf7z26vp">
                  {zones.map((zone, i) => <motion.div key={i} initial={{
                  opacity: 0,
                  x: -10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.3,
                  delay: 0.6 + i * 0.05
                }} className={`flex items-center justify-between px-3 py-2.5 rounded-xl ${zone.active ? 'bg-accent/20 border border-accent/40' : 'bg-white/[0.04] border border-white/10'}`} data-id="element-716" data-mp="1f69afsdqch8r" data-mpi={i}>
                      <span className={`text-xs font-medium ${zone.active ? 'text-white' : 'text-white/40'}`} data-id="element-717" data-mp="13jvkrtn3ot8">
                        {zone.name}
                      </span>
                      <span className={`text-xs tabular-nums font-semibold ${zone.active ? 'text-accent' : 'text-white/30'}`} data-id="element-718" data-mp="3nhjs17sysflo">
                        {zone.temp}
                      </span>
                    </motion.div>)}
                </div>
              </motion.div>

              <motion.div initial={{
              opacity: 0,
              x: 30
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: 0.7
            }} className="absolute top-12 right-6 lg:right-8 bg-white text-ink rounded-2xl px-4 py-3 shadow-2xl" data-id="element-719" data-mp="34k8v3tut1y9e">
                <div className="text-[10px] uppercase tracking-widest text-stone-500 font-semibold" data-id="element-720" data-mp="bqfov8a1uadp">
                  Savings vs no zoning
                </div>
                <div className="text-2xl font-extrabold tracking-tight tabular-nums text-brand" data-id="element-721" data-mp="1x75zqmh5qil">
                  ~40%
                </div>
                <div className="text-[10px] text-stone-500" data-id="element-722" data-mp="3k6her51ao917">
                  power use, on average
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}